import { Accordion, AccordionDetails, AccordionSummary, Button, Checkbox, CircularProgress, FormControlLabel, makeStyles, Typography } from '@material-ui/core'
import { observer } from 'mobx-react-lite'
import React from 'react'
import { ProgressPushMessage } from '../../models/ProgressPushMessage'
import { MainStore } from '../../stores/MainStore'
import ProgressBar from '../controls/ProgressBar'

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
        backgroundColor: 'white',
        border: "1px solid #BFC5CD",
        margin: '5px 0',
    },
    heading: {
        fontSize: theme.typography.pxToRem(15),
        // fontWeight: theme.typography.fontWeightRegular, // this fails compilation
    }
}));

type ProcessProps = {
    store: MainStore
}

export const Process = observer(({ store }: ProcessProps) => {
    const classes = useStyles()
    const [state, setState] = React.useState(0)
    const [ct, setCt] = React.useState<string | undefined>(undefined)
    const [runValidations, setRunValidations] = React.useState<boolean>(true)
    const { processProgress } = store

    const onProcess = (runValidations: boolean) => {
        setState(1)
        store.process(runValidations)
            .then((res) => {
                setState(3)
                setCt(res)
            })
            .catch((error) => {
                console.error('Process failed:', error)
                setState(2)
            })
    }

    const onValidate = () => {
        setState(1)
        store.validate()
            .then(() => {
                setState(3)
            })
            .catch((error) => {
                console.error('Validate failed:', error)
                setState(2)
            })
    }

    const onCancel = () => {
        if (!ct) return
        store.cancelOperation(ct)
        setCt(undefined)
    }

    const renderItem = (message: ProgressPushMessage) => {
        return <div key={message.subject} className={classes.root} style={{ marginBottom: message.subject === 'Complete Process' ? 20 : 0 }}>
            <Accordion
                expanded={message.state === 'fail' || message.state === 'warn'}>
                <AccordionSummary
                    expandIcon={<React.Fragment />}
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                >
                    <div style={{ display: 'flex', flexDirection: 'row', width: '100%' }}>
                        <Typography className={classes.heading} style={{ marginRight: 20, marginLeft: 20, width: 160 }}>{message.subject === 'Complete Process' ? 'Overall' : message.subject}</Typography>
                        <ProgressBar
                            style={{ marginLeft: 20 }}
                            fillColor={message.state && message.state === 'fail' ? 'red' : message.state && message.state === 'warn' ? '#eed202' : message.subject === 'Complete Process' ? '#57D89D' : '#17B1E2'}
                            completed={message.progress} />
                    </div>
                </AccordionSummary>
                <AccordionDetails>
                    <div>
                        {message.message && message.message.split('\n').map((i, key) => {
                            return <Typography key={key} paragraph variant="body1">{i}</Typography>;
                        })}
                    </div>
                </AccordionDetails>
            </Accordion>
        </div>
    }



    return (
        <>
            <div style={{ width: '100%' }}>
                <Button variant='outlined' onClick={()=> onProcess(runValidations)}>Process</Button>
                <Button style={{ marginLeft: 10 }} variant='outlined' onClick={()=> onValidate()}>Validate</Button>
                <Button style={{ marginLeft: 10 }} variant='outlined' onClick={onCancel}>Cancel</Button>
                <FormControlLabel style={{ marginLeft: 10 }}
                    control={
                        <Checkbox
                            checked={runValidations}
                            onChange={() => setRunValidations(!runValidations)}
                            name="checkedB"
                            color="primary"
                        />
                    }
                    label="Run Validations"
                />
                {processProgress.length > 0 && processProgress.map(item => renderItem(item))}
                {state === 1 && processProgress.length === 0 && <CircularProgress />}
                {state === 2 && <Typography>Error</Typography>}
            </div>
        </>
    )
})